export default __webpack_public_path__ + "static/media/product3.d6072486.png";